module.exports = __webpack_public_path__ + "static/media/37_B.07047f7c.png";